export default "__VITE_ASSET__DaZA0kFs__"